import React from 'react';
import { displayCEP } from '@iso/lib/helpers/utility';
import { Page, Document, Text, StyleSheet, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft: 30,
        paddingRight: 30,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    title: {
        fontSize:18,
        fontFamily: 'Helvetica-Bold',
    },
    title2: {
        fontSize:12,
        textTransform:'uppercase',
        fontFamily: 'Helvetica-Bold'
    },
    box:{
        width: '100%',
        padding:'5px',
        border: '1px solid #000000',
        color:'#000000',
        borderRadius:'1px',
        textAlign:'left'
    },
});

const ShippingLabel = ({ data }) => {
    return (
        <Document>
            <Page size="A4" orientation='portrait' style={styles.page} wrap={true}>
                <View style={{ flexDirection: 'column', width:'50%', transform:'rotate(270)' }}>
                    <View style={styles.box}>
                        <Text style={styles.title}>DESTINATÁRIO</Text>
                        <Text style={styles.title2}>{data.client.name}</Text>
                        <Text>
                            {(data.client.address) ? 
                                <>
                                   { (data.client.address.address) ? data.client.address.address : ''}
                                   { (data.client.address.numberHouse) ? `, nº ${data.client.address.numberHouse}` : ''}
                                   { (data.client.address.complement) ? ` - ${data.client.address.complement}` : ''}
                                </>
                                : <></>
                            }
                        </Text>
                        <Text>
                            {(data.client.address) ? 
                                <>
                                   { (data.client.address.neighborhood) ? data.client.address.neighborhood : ''}
                                   { (data.client.address.city) ? ` - ${data.client.address.city}` : ''}
                                   { (data.client.address.state) ? ` - ${data.client.address.state}` : ''}
                                </>
                                : <></>
                            }
                        </Text>
                        <Text>
                            {(data.client.address) ? 
                                <>
                                   { (data.client.address.cep) ? `CEP: ${displayCEP(data.client.address.cep)}` : ''}
                                </>
                                : <></>
                            }
                        </Text>
                    </View>
                    <View style={{ ...styles.box, marginTop:'20px' }}>
                        <Text style={styles.title}>REMETENTE</Text>
                        <Text style={styles.title2}>{data.empresa.name}</Text>
                        <Text>
                            {(data.empresa.address) ? 
                                <>
                                   { (data.empresa.address.address) ? data.empresa.address.address : ''}
                                   { (data.empresa.address.numberHouse) ? `, nº ${data.empresa.address.numberHouse}` : ''}
                                   { (data.empresa.address.complement) ? ` - ${data.empresa.address.complement}` : ''}
                                </>
                                : <></>
                            }
                        </Text>
                        <Text>
                            {(data.empresa.address) ? 
                                <>
                                   { (data.empresa.address.neighborhood) ? data.empresa.address.neighborhood : ''}
                                   { (data.empresa.address.city) ? ` - ${data.empresa.address.city}` : ''}
                                   { (data.empresa.address.state) ? ` - ${data.empresa.address.state}` : ''}
                                </>
                                : <></>
                            }
                        </Text>
                        <Text>
                            {(data.empresa.address) ? 
                                <>
                                   { (data.empresa.address.cep) ? `CEP: ${displayCEP(data.empresa.address.cep)}` : ''}
                                </>
                                : <></>
                            }
                        </Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default ShippingLabel